function doHandleMonth(month) {
    var m = month;
    if (month.toString().length == 1) {
        m = "0" + month;
    }
    return m;
}
export function getDay(day) {
    var today = new Date();

    var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;

    today.setTime(targetday_milliseconds); //注意，这行是关键代码    

    var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    tMonth = doHandleMonth(tMonth + 1);
    tDate = doHandleMonth(tDate);
    return {
        date: tYear + "-" + tMonth + "-" + tDate,
        shortDate: tMonth + "." + tDate
    }


}
export const pageSize=20;
export function getOneDay(day){  //0代表今天  -1代表前一天
    function doHandleMonth(month){
        var m = month;
        if(month.toString().length == 1){
           m = "0" + month;
        }
        return m;
    }
    var today = new Date();

    var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;

    today.setTime(targetday_milliseconds); //注意，这行是关键代码

    var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    tMonth = doHandleMonth(tMonth + 1);
    tDate = doHandleMonth(tDate);
    return tYear+"-"+tMonth+"-"+tDate;
}
/**
 *获得本月的开始日期和结束日期
 */
export const getMonthStartDateAndDateRange = () => {
    let oneDayLong = 24*60*60*1000;
    let now = new Date();
    let year = now.getFullYear();
    // console.log(now+","+year);
    // let monthStartDate = new Date(year, now.getMonth()+1, 1);//当前月1号
    let monthStartDate = new Date(year, now.getMonth(), 1);//当前月1号
    // let nextMonthStartDate = new Date(year, now.getMonth()+2, 1);//下个月1号
    let nextMonthStartDate = new Date(year, now.getMonth()+1, 1);//下个月1号
    let days = (nextMonthStartDate.getTime() -
      monthStartDate.getTime())/oneDayLong;//计算当前月份的天数
    // let monthEndDate = new Date(year, now.getMonth()+1, days);
    let monthEndDate = new Date(year, now.getMonth(), days);
    let monthRange = [monthStartDate,monthEndDate];
    // console.log(monthRange);
    return monthRange;
  }


  export const _dateFormatMySelf=(dates)=>{
    let date = new Date(dates)
    let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
    let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    return `${date.getFullYear()}-${month}-${day}`;
}
/**
 * 获得本周的开始日期和结束日期
 */
export const getWeekStartDateAndEndDateRange = () => {
    let oneDayLong = 24*60*60*1000 ;
    let now = new Date();
    let day=now.getDay();
    day==0&&(day=7);
    let mondayTime = now.getTime() - (day-1)*oneDayLong;
    let sundayTime = now.getTime() + (7-day)*oneDayLong;
    let monday = new Date(mondayTime);
    let sunday = new Date(sundayTime);
    let weekRange = [monday, sunday];
    //console.log(weekRange);
    return weekRange;
  }

  export const PDscroll=(classname,callback,num)=>{
    let a=document.getElementsByClassName(classname)[0];
    console.log(a)
    a.addEventListener("scroll",()=>{
        // 变量scrollTop为当前页面的滚动条纵坐标位置
            let scrollTop =
            a.scrollTop || a.scrollTop;
        // 变量 windowHeight 是可视区的高度
        let windowHeight =
            document.documentElement.clientHeight || document.body.clientHeight;
        // 变量 scrollHeight 是滚动条的总高度
        let scrollHeight =
        a.scrollHeight || a.scrollHeight;

        console.log(scrollTop,windowHeight,scrollHeight)
        // 到底的条件
        if (
            scrollTop + windowHeight +10> scrollHeight
        ) {
            callback();
        }
    })
  }